// VersionService.ts
export class VersionService {
    private _versionId: string | null = null;

    getVersionId(): string | null {
        return this._versionId;
    }

    setVersionId(versionId: string | null): void {
        this._versionId = versionId;
    }
}

// Register as BPMN.js DI module type
export default {
    __init__: ['versionService'],
    versionService: ['type', VersionService],
};
